import Header from 'components/headers/bulletins'
import useGetMoneyPoolManagement from '../fundPage/hooks/useGetMoneyPoolManagement'
import { useNavigate, useParams } from 'react-router-dom'
import SettingHeader from './header'
import DotsLoading from 'components/loadings/dotsLoading'

import BackIcon from 'assets/images/settingFund/chevron_left.svg'
import { myLists } from './utils'
import { toast } from 'react-toastify'
export default function Setting() {
    const { id } = useParams()
    const navigate = useNavigate()
    const { moneyPoolManagement, isLoadingMoneypoolManagement } =
        useGetMoneyPoolManagement(id)
    return (
        <>
            <Header title="تنظیمات صندوق" />
            {!isLoadingMoneypoolManagement && moneyPoolManagement ? (
                <>
                    <SettingHeader
                        imageId={moneyPoolManagement.image_id}
                        avatar={moneyPoolManagement.custom_avatar}
                        name={moneyPoolManagement.name}
                        date={moneyPoolManagement.jalali_due_date}
                        shareValueAmount={
                            moneyPoolManagement.share_value_amount
                        }
                    />
                    <div className=" w-full">
                        {myLists.map((item, index) => (
                            <div
                                className="flex justify-between mx-2 my-4 items-start"
                                onClick={() =>
                                    !item.disable
                                        ? navigate(item.route + id, {
                                              state: {
                                                  service_package:
                                                      moneyPoolManagement.service_package,
                                              },
                                          })
                                        : toast.error(
                                              'این صفحه در حال پیاده سازی می باشد'
                                          )
                                }
                                key={index}
                            >
                                <div className=" flex w-full items-start">
                                    <img src={item.icon} alt="management" />
                                    <div>
                                        <p className=" mx-2 text-sm w-full">
                                            {item.title}
                                        </p>
                                        {item.subtext && (
                                            <p className=" text-gray-4 text-xs mx-2 my-1">
                                                {item.subtext}
                                            </p>
                                        )}
                                    </div>
                                </div>
                                <img src={BackIcon} alt="back" />
                            </div>
                        ))}
                    </div>
                </>
            ) : (
                <DotsLoading />
            )}
        </>
    )
}
